<div>
    <app-error-alert title="Could not login by microsoft 365, please click 'Go back' button on your browser, log out of Microsoft services and try again" i18n-title="Could not login by microsoft 365"
    [errors]="submitErrors"></app-error-alert>
</div>
